module.exports = __webpack_public_path__ + "img/offline.3747237e.png";